import {AddressInput, CustomerAddressResponse} from "@/shared/graphql/types";
// @ts-ignore
import MAKE_DEFAULT_ADDRESS_MUTATION from "@/shared/graphql/customer/delivery/customer.makedefault.deliveryaddress.mutation.graphql";
// @ts-ignore
import DELETE_DELIVERY_ADDRESS from "@/shared/graphql/customer/delivery/customer.delete.deliveryaddress.mutation.graphql"
// @ts-ignore
import CREATE_DELIVERY_ADDRESS from "@/shared/graphql/customer/delivery/customer.create.deliveryaddress.mutation.graphql";
// @ts-ignore
import UPDATE_BILLING_ADDRESS from "@/shared/graphql/customer/billing/customer.update.billingaddress.mutation.graphql";

import {getApolloClient} from "@/shared/apolloclient/apollo.client.ts";
import {extractGraphData} from "@/shared/composable/service.composables.ts";
import {activeLanguage} from "@/shared/i18n/i18n.ts";

class AddressService {
    makeAddressDefault = async (customerId: string, addressId: string): Promise<CustomerAddressResponse> => {
        const variables = {
            language: activeLanguage(),
            deliveryAddressId: addressId,
            customerId: customerId
        };
        try {
            const response = await getApolloClient().mutate({
                mutation: MAKE_DEFAULT_ADDRESS_MUTATION,
                variables: variables,
                fetchPolicy: 'network-only'
            });
            return extractGraphData(response?.data);
        } catch (e) {
            throw e;
        }
    }

    deleteAddress = async (customerId: string, addressId: string): Promise<CustomerAddressResponse> => {
        const variables = {
            language: activeLanguage(),
            addressId: addressId,
            customerId: customerId
        }
        console.log(variables)
        try {
            const response = await getApolloClient().mutate({
                mutation: DELETE_DELIVERY_ADDRESS,
                variables: variables,
                fetchPolicy: 'network-only'
            });
            return extractGraphData(response?.data)
        } catch (e) {
            throw e
        }
    }

    createAddress = async (customerId: string, addressInput: AddressInput): Promise<CustomerAddressResponse> => {
        const variables = {
            language: activeLanguage(),
            addressInput: addressInput,
            customerId: customerId
        }
        try {
            const response = await getApolloClient().mutate({
                mutation: CREATE_DELIVERY_ADDRESS,
                variables: variables,
                fetchPolicy: 'network-only'
            });
            return extractGraphData(response?.data)
        } catch (e) {
            throw e
        }
    }
    updateBillingAddress = async (customerId: string, addressInput: AddressInput): Promise<CustomerAddressResponse> => {
        const variables = {
            language: activeLanguage(),
            addressInput: addressInput,
            customerId: customerId
        }
        try {
            const response = await getApolloClient().mutate({
                mutation: UPDATE_BILLING_ADDRESS,
                variables: variables,
                fetchPolicy: 'network-only'
            });
            return extractGraphData(response?.data)
        } catch (e) {
            throw e
        }
    }
}

// Export an instance of the service for use elsewhere in your application
export const addressService = new AddressService();